
import { Mixins, Component, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import ModuleLoader from '@/_components/loader/module/module.vue'

import { hasBklrModule } from '@/views/Project/Bklr/plugins/bklr'
import Authentication from '@/views/Authentication/models/authentication'

@Component({
    components: { ModuleLoader },
})
export default class Bkrl extends Mixins<MixinInterface>() {
    @Prop({ required: true }) lang!: string
    token = null
    loading = false

    get bklrLoading() {
        return this.$store.getters.bklrLoading
    }

    get bklrId() {
        return this.currentProject ? this.currentProject.attributes.bklrId : false
    }

    get hasBklr() {
        return hasBklrModule(this.currentProject)
    }

    async mounted() {
        this.loading = true
        if (!this.bklrLoading && !this.token) {
            this.token = await Authentication.postJWT()
        }
        this.loading = false
    }

    get url() {
        return this.bklrId.startsWith('ID06') ? 'checkbox.itbase.se' : 'v2.byggekortleser.no'
    }

    get src() {
        return this.bklrId && this.token
            ? `https://${this.url}/ext/VBIT.aspx?ProjectId=${this.bklrId}&Token=${this.token}&Language=${this.lang}`
            : null
    }
}
